module.exports = "<div class=\"container alert alert-danger\">\n  <ng-content></ng-content>\n</div>\n"